// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root___vcBR","error":"Textarea_error__2TsI0","readonly":"Textarea_readonly__1rcOh","disabled":"Textarea_disabled__1ZFs3"};